import React, { useEffect } from "react";
import { callAPI } from "../../utils.js";
import {
  getPowerTranzRedirect,
  loadPowerTranzRedirect,
} from "../../add-card/powertranz/PowerTranz.utils.js";

const getErrorMessage = (error) =>
  error?.response?.data?.response?.message ??
  error?.response?.data?.message ??
  error?.message ??
  "Unable to start PowerTranz verification.";

export default function PowerTranz(props) {
  const { alert, setIsLoading, token } = props;

  useEffect(() => {
    const fetchRedirectForm = async () => {
      setIsLoading(true);
      try {
        const response = await callAPI(
          `${process.env.REACT_APP_WEBHOOK_API_ENDPOINT}/api/webhook/powerTranzPayWithToken3DSForm`,
          "POST",
          { key: token }
        );
        const nextStep = getPowerTranzRedirect(response);
        if (nextStep.returnCode !== 200) {
          alert(nextStep.message ?? `PowerTranz error: ${nextStep.returnCode}`);
          return;
        }
        if (nextStep.html || nextStep.url) {
          loadPowerTranzRedirect(nextStep);
          return;
        }
        alert("PowerTranz did not return 3DS redirect data.");
      } catch (error) {
        alert(getErrorMessage(error));
      } finally {
        setIsLoading(false);
      }
    };

    if (!token) {
      alert("PowerTranz verification key is missing.");
      return;
    }
    fetchRedirectForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return <></>;
}
